// import React, { useState, useEffect, useContext } from 'react';
// import AuthContext from "../contexts/AuthContext";
// import axios from 'axios';
// import ProjectDashboard from './ProjectDashboard';
// import ProjectHistory from './ProjectHistory';
// import UpdateStatusModal from './UpdateStatusModal';
// import CriticalAlerts from './CriticalAlerts';
// import { ProjectStatusTrackerItems } from "../data";
// import Layout from "../components/Layout";
// import { Sidebar } from "../components";

// const ProjectStatusTracker = () => {
//   const {authTokens, user } = useContext(AuthContext);
//   const [dashboardData, setDashboardData] = useState(null);
//   const [selectedProject, setSelectedProject] = useState(null);
//   const [showUpdateModal, setShowUpdateModal] = useState(false);
//   const [showHistory, setShowHistory] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const userRole = user?.user_role || user?.role;
//   const userId = user?.id;
//   const isCEO = userRole === 'CEO';

//   const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://ess-api-django-a6fc2c26f42e.herokuapp.com';

//   useEffect(() => {
//     if (authTokens?.access) {
//       fetchDashboard();
//     }
//   }, [authTokens]);

//   const fetchDashboard = async () => {
//     if (!authTokens?.access) {
//       console.log('No auth tokens available');
//       setLoading(false);
//       return;
//     }

//     try {
//       setLoading(true);
//       const response = await fetch(`${API_BASE_URL}/api/timesheet/project-status/dashboard/`, {
//         headers: {
//           Authorization: "Bearer " + String(authTokens.access),
//           'Content-Type': 'application/json',
//         },
//       });

//       // Check for 401 Unauthorized error
//       if (response.status === 401) {
//         const hasReloaded = sessionStorage.getItem('projectStatus401Reload');
        
//         // Reload once if not already reloaded
//         if (!hasReloaded) {
//           console.log('401 Unauthorized - Reloading page to refresh token');
//           sessionStorage.setItem('projectStatus401Reload', 'true');
//           window.location.reload();
//           return;
//         } else {
//           // If already reloaded once, clear flag and show error
//           sessionStorage.removeItem('projectStatus401Reload');
//           throw new Error('Authentication failed. Please login again.');
//         }
//       }

//       if (!response.ok) {
//         throw new Error('Failed to fetch dashboard data');
//       }

//       const data = await response.json();
//       setDashboardData(data);
//       setError(null);
      
//       // Clear reload flag on successful fetch
//       sessionStorage.removeItem('projectStatus401Reload');
      
//     } catch (err) {
//       setError(err.message || 'Failed to load dashboard data');
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleUpdateStatus = (project) => {
//     setSelectedProject(project);
//     setShowUpdateModal(true);
//   };

//   const handleViewHistory = (project) => {
//     setSelectedProject(project);
//     setShowHistory(true);
//   };

//   const handleStatusUpdated = () => {
//     setShowUpdateModal(false);
//     setSelectedProject(null);
//     fetchDashboard();
//   };

//   const handleCloseHistory = () => {
//     setShowHistory(false);
//     setSelectedProject(null);
//   };

//   const styles = {
//     container: {
//       padding: '24px',
//       maxWidth: '1400px',
//       margin: '0 auto'
//     },
//     header: {
//       marginBottom: '32px'
//     },
//     title: {
//       fontSize: '28px',
//       fontWeight: '700',
//       color: '#111827',
//       margin: '0 0 8px 0'
//     },
//     subtitle: {
//       color: '#6b7280',
//       fontSize: '14px',
//       margin: '0'
//     },
//     loadingContainer: {
//       display: 'flex',
//       flexDirection: 'column',
//       alignItems: 'center',
//       justifyContent: 'center',
//       minHeight: '400px',
//       gap: '16px'
//     },
//     spinner: {
//       width: '40px',
//       height: '40px',
//       border: '4px solid #f3f4f6',
//       borderTopColor: '#3b82f6',
//       borderRadius: '50%',
//       animation: 'spin 1s linear infinite'
//     },
//     errorContainer: {
//       display: 'flex',
//       flexDirection: 'column',
//       alignItems: 'center',
//       justifyContent: 'center',
//       minHeight: '400px',
//       gap: '16px'
//     },
//     retryButton: {
//       padding: '8px 16px',
//       backgroundColor: '#3b82f6',
//       color: 'white',
//       border: 'none',
//       borderRadius: '6px',
//       cursor: 'pointer',
//       fontSize: '14px'
//     }
//   };

//   if (loading) {
//     return (
//       <Layout
//         sidebar={
//           user?.user_role ? (
//             <Sidebar sidebarLinks={ProjectStatusTrackerItems} />
//           ) : null
//         }
//       >
//         <div style={styles.loadingContainer}>
//           <div style={styles.spinner}></div>
//           <p>Loading project statuses...</p>
//           <style>
//             {`
//               @keyframes spin {
//                 to { transform: rotate(360deg); }
//               }
//             `}
//           </style>
//         </div>
//       </Layout>
//     );
//   }

//   if (error) {
//     return (
//       <Layout
//         sidebar={
//           user?.user_role ? (
//             <Sidebar sidebarLinks={ProjectStatusTrackerItems} />
//           ) : null
//         }
//       >
//         <div style={styles.errorContainer}>
//           <p>{error}</p>
//           <button 
//             style={styles.retryButton}
//             onMouseOver={(e) => e.target.style.backgroundColor = '#2563eb'}
//             onMouseOut={(e) => e.target.style.backgroundColor = '#3b82f6'}
//             onClick={fetchDashboard}
//           >
//             Retry
//           </button>
//         </div>
//       </Layout>
//     );
//   }

//   return (
//     <Layout
//       sidebar={
//         user?.user_role ? (
//           <Sidebar sidebarLinks={ProjectStatusTrackerItems} />
//         ) : null
//       }
//     >
//       <div style={styles.container}>
//         <div style={styles.header}>
//           <h1 style={styles.title}>Project Status Tracker</h1>
//           <p style={styles.subtitle}>
//             {isCEO ? 'Consolidated view of all projects' : 'Manage your project statuses'}
//           </p>
//         </div>

//         {isCEO && <CriticalAlerts authTokens={authTokens} />}

//         <ProjectDashboard
//           data={dashboardData}
//           onUpdateStatus={handleUpdateStatus}
//           onViewHistory={handleViewHistory}
//           userRole={userRole}
//         />

//         {showUpdateModal && (
//           <UpdateStatusModal
//             project={selectedProject}
//             onClose={() => setShowUpdateModal(false)}
//             onSuccess={handleStatusUpdated}
//             authTokens={authTokens}
//           />
//         )}

//         {showHistory && (
//           <ProjectHistory
//             project={selectedProject}
//             onClose={handleCloseHistory}
//             authTokens={authTokens}
//           />
//         )}
//       </div>
//     </Layout>
//   );
// };

// export default ProjectStatusTracker;


import React, { useState, useEffect, useContext } from 'react';
import AuthContext from "../contexts/AuthContext";
import ProjectDashboard from './ProjectDashboard';
import ProjectHistory from './ProjectHistory';
import UpdateStatusModal from './UpdateStatusModal';
import CriticalAlerts from './CriticalAlerts';
import AddProjectModal from './AddProjectModal';
import { ProjectStatusTrackerItems } from "../data";
import Layout from "../components/Layout";
import { Sidebar } from "../components";

const ProjectStatusTracker = () => {
  const {authTokens, user } = useContext(AuthContext);
  const [dashboardData, setDashboardData] = useState(null);
  const [filterOptions, setFilterOptions] = useState({ managers: [], status_options: [] });
  const [selectedProject, setSelectedProject] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [showAddProjectModal, setShowAddProjectModal] = useState(false);
  const [showHistory, setShowHistory] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  // Filter states
  const [filters, setFilters] = useState({
    manager_id: '',
    project_name: '',
    status: ''
  });

  const userRole = user?.user_role || user?.role;
  const userId = user?.id;
  const isCEO = userRole === 'CEO';

  const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://ess-api-django-a6fc2c26f42e.herokuapp.com';

  useEffect(() => {
    if (authTokens?.access) {
      fetchDashboard();
    }
  }, [authTokens, filters]);

  const fetchDashboard = async () => {
    if (!authTokens?.access) {
      console.log('No auth tokens available');
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      
      // Build query string
      const queryParams = new URLSearchParams();
      if (filters.manager_id) queryParams.append('manager_id', filters.manager_id);
      if (filters.project_name) queryParams.append('project_name', filters.project_name);
      if (filters.status) queryParams.append('status', filters.status);
      
      const url = `${API_BASE_URL}/api/timesheet/project-status/dashboard/?${queryParams.toString()}`;
      
      const response = await fetch(url, {
        headers: {
          Authorization: "Bearer " + String(authTokens.access),
          'Content-Type': 'application/json',
        },
      });

      if (response.status === 401) {
        const hasReloaded = sessionStorage.getItem('projectStatus401Reload');
        if (!hasReloaded) {
          console.log('401 Unauthorized - Reloading page to refresh token');
          sessionStorage.setItem('projectStatus401Reload', 'true');
          window.location.reload();
          return;
        } else {
          sessionStorage.removeItem('projectStatus401Reload');
          throw new Error('Authentication failed. Please login again.');
        }
      }

      if (!response.ok) {
        throw new Error('Failed to fetch dashboard data');
      }

      const data = await response.json();
      setDashboardData(data.projects);
      setFilterOptions(data.filters || { managers: [], status_options: [] });
      setError(null);
      sessionStorage.removeItem('projectStatus401Reload');
      
    } catch (err) {
      setError(err.message || 'Failed to load dashboard data');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateStatus = (project, statusToEdit = null) => {
    setSelectedProject(project);
    setSelectedStatus(statusToEdit);
    setShowUpdateModal(true);
  };

  const handleViewHistory = (project) => {
    setSelectedProject(project);
    setShowHistory(true);
  };

  const handleStatusUpdated = () => {
    setShowUpdateModal(false);
    setSelectedProject(null);
    setSelectedStatus(null);
    fetchDashboard();
  };

  const handleCloseHistory = () => {
    setShowHistory(false);
    setSelectedProject(null);
  };

  const handleProjectAdded = () => {
    setShowAddProjectModal(false);
    fetchDashboard();
  };

  const handleFilterChange = (filterName, value) => {
    setFilters(prev => ({
      ...prev,
      [filterName]: value
    }));
  };

  const clearFilters = () => {
    setFilters({
      manager_id: '',
      project_name: '',
      status: ''
    });
  };

  const styles = {
    container: {
      padding: '24px',
      maxWidth: '1400px',
      margin: '0 auto'
    },
    header: {
      marginBottom: '24px'
    },
    topRow: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '16px',
      flexWrap: 'wrap',
      gap: '12px'
    },
    titleSection: {
      flex: 1
    },
    title: {
      fontSize: '28px',
      fontWeight: '700',
      color: '#111827',
      margin: '0 0 8px 0'
    },
    subtitle: {
      color: '#6b7280',
      fontSize: '14px',
      margin: '0'
    },
    addButton: {
      padding: '10px 20px',
      backgroundColor: '#3b82f6',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      fontSize: '14px',
      fontWeight: '600',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      transition: 'all 0.2s'
    },
    filtersSection: {
      backgroundColor: 'white',
      padding: '20px',
      borderRadius: '12px',
      marginBottom: '24px',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
    },
    filtersTitle: {
      fontSize: '16px',
      fontWeight: '600',
      color: '#111827',
      marginBottom: '16px'
    },
    filtersGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
      gap: '16px',
      marginBottom: '16px'
    },
    filterField: {
      display: 'flex',
      flexDirection: 'column',
      gap: '6px'
    },
    filterLabel: {
      fontSize: '13px',
      fontWeight: '500',
      color: '#374151'
    },
    filterInput: {
      padding: '8px 12px',
      border: '1px solid #d1d5db',
      borderRadius: '6px',
      fontSize: '14px',
      fontFamily: 'inherit'
    },
    filterActions: {
      display: 'flex',
      gap: '8px'
    },
    clearButton: {
      padding: '8px 16px',
      backgroundColor: '#f3f4f6',
      color: '#374151',
      border: '1px solid #d1d5db',
      borderRadius: '6px',
      fontSize: '13px',
      fontWeight: '500',
      cursor: 'pointer',
      transition: 'all 0.2s'
    },
    loadingContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '400px',
      gap: '16px'
    },
    spinner: {
      width: '40px',
      height: '40px',
      border: '4px solid #f3f4f6',
      borderTopColor: '#3b82f6',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite'
    },
    errorContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '400px',
      gap: '16px'
    },
    retryButton: {
      padding: '8px 16px',
      backgroundColor: '#3b82f6',
      color: 'white',
      border: 'none',
      borderRadius: '6px',
      cursor: 'pointer',
      fontSize: '14px'
    }
  };

  if (loading) {
    return (
      <Layout
        sidebar={
          user?.user_role ? (
            <Sidebar sidebarLinks={ProjectStatusTrackerItems} />
          ) : null
        }
      >
        <div style={styles.loadingContainer}>
          <div style={styles.spinner}></div>
          <p>Loading project statuses...</p>
          <style>
            {`
              @keyframes spin {
                to { transform: rotate(360deg); }
              }
            `}
          </style>
        </div>
      </Layout>
    );
  }

  if (error) {
    return (
      <Layout
        sidebar={
          user?.user_role ? (
            <Sidebar sidebarLinks={ProjectStatusTrackerItems} />
          ) : null
        }
      >
        <div style={styles.errorContainer}>
          <p>{error}</p>
          <button 
            style={styles.retryButton}
            onMouseOver={(e) => e.target.style.backgroundColor = '#2563eb'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#3b82f6'}
            onClick={fetchDashboard}
          >
            Retry
          </button>
        </div>
      </Layout>
    );
  }

  return (
    <Layout
      sidebar={
        user?.user_role ? (
          <Sidebar sidebarLinks={ProjectStatusTrackerItems} />
        ) : null
      }
    >
      <div style={styles.container}>
        <div style={styles.header}>
          <div style={styles.topRow}>
            <div style={styles.titleSection}>
              <h1 style={styles.title}>Project Status Tracker</h1>
              <p style={styles.subtitle}>
                {isCEO ? 'Consolidated view of all projects' : 'Manage your project statuses'}
              </p>
            </div>
            <button 
              style={styles.addButton}
              onClick={() => setShowAddProjectModal(true)}
              onMouseOver={(e) => e.target.style.backgroundColor = '#2563eb'}
              onMouseOut={(e) => e.target.style.backgroundColor = '#3b82f6'}
            >
              <span style={{ fontSize: '18px' }}>+</span>
              Add New Project
            </button>
          </div>

        {isCEO && filterOptions.managers && filterOptions.managers.length > 0 && (
            <div style={styles.filtersSection}>
              <h3 style={styles.filtersTitle}>Filters</h3>
              <div style={styles.filtersGrid}>
                <div style={styles.filterField}>
                  <label style={styles.filterLabel}>Manager</label>
                  <select
                    style={styles.filterInput}
                    value={filters.manager_id}
                    onChange={(e) => handleFilterChange('manager_id', e.target.value)}
                  >
                    <option value="">All Managers</option>
                    {filterOptions.managers.map(manager => (
                      <option key={manager.id} value={manager.id}>
                        {manager.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div style={styles.filterField}>
                  <label style={styles.filterLabel}>Project Name</label>
                  <input
                    type="text"
                    style={styles.filterInput}
                    placeholder="Search by project name..."
                    value={filters.project_name}
                    onChange={(e) => handleFilterChange('project_name', e.target.value)}
                  />
                </div>

                <div style={styles.filterField}>
                  <label style={styles.filterLabel}>Status</label>
                  <select
                    style={styles.filterInput}
                    value={filters.status}
                    onChange={(e) => handleFilterChange('status', e.target.value)}
                  >
                    <option value="">All Status</option>
                    {filterOptions.status_options.map(option => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div style={styles.filterActions}>
                <button
                  style={styles.clearButton}
                  onClick={clearFilters}
                  onMouseOver={(e) => e.target.style.backgroundColor = '#e5e7eb'}
                  onMouseOut={(e) => e.target.style.backgroundColor = '#f3f4f6'}
                >
                  Clear Filters
                </button>
              </div>
            </div>
          )}
        </div>

        {isCEO && <CriticalAlerts authTokens={authTokens} />}

        <ProjectDashboard
          data={dashboardData}
          onUpdateStatus={handleUpdateStatus}
          onViewHistory={handleViewHistory}
          userRole={userRole}
        />

        {showUpdateModal && (
          <UpdateStatusModal
            project={selectedProject}
            statusToEdit={selectedStatus}
            onClose={() => {
              setShowUpdateModal(false);
              setSelectedStatus(null);
            }}
            onSuccess={handleStatusUpdated}
            authTokens={authTokens}
          />
        )}

        {showAddProjectModal && (
          <AddProjectModal
            onClose={() => setShowAddProjectModal(false)}
            onSuccess={handleProjectAdded}
            authTokens={authTokens}
          />
        )}

        {showHistory && (
          <ProjectHistory
            project={selectedProject}
            onClose={handleCloseHistory}
            onEditStatus={handleUpdateStatus}
            authTokens={authTokens}
          />
        )}
      </div>
    </Layout>
  );
};

export default ProjectStatusTracker;